module.exports = __webpack_public_path__ + "static/media/discussion.501681d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/discussion.jpg
// module id = 220
// module chunks = 0